// import React from 'react';
// import { MapPin, Calendar } from 'lucide-react'; // Optional: For nice iconography

// const EventSchedule = () => {
//   const events = [
//     {
//       hotel: "ITC Grand Chola",
//       city: "Chennai",
//       date: "June 1 - 5, 2027",
//       bgGradient: "from-amber-500/10 to-orange-500/10",
//       borderColor: "group-hover:border-amber-500",
//       textColor: "text-amber-600"
//     },
//     {
//       hotel: "ITC Royal Bengal",
//       city: "Bengaluru",
//       date: "June 1 - 5, 2028",
//       bgGradient: "from-blue-500/10 to-indigo-500/10",
//       borderColor: "group-hover:border-blue-500",
//       textColor: "text-blue-600"
//     }
//   ];

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
//       <div className="w-full max-w-4xl">
//         {/* Section Header */}
//         <div className="text-center mb-10">
//           <h2 className="text-3xl font-bold text-gray-900 tracking-tight sm:text-4xl">
//             Upcoming Destinations
//           </h2>
//           <p className="mt-2 text-lg text-gray-500">
//             Join us for our upcoming annual flagship events.
//           </p>
//         </div>

//         {/* Event Cards Grid */}
//         <div className="grid gap-6 md:grid-cols-2">
//           {events.map((event, index) => (
//             <div
//               key={index}
//               className={`group relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${event.borderColor}`}
//             >
//               {/* Subtle background glow on hover */}
//               <div className={`absolute inset-0 bg-gradient-to-br ${event.bgGradient} opacity-0 transition-opacity duration-300 group-hover:opacity-100`} />

//               <div className="relative z-10 flex flex-col h-full justify-between">
//                 <div>
//                   {/* City & Year Tag */}
//                   <div className="flex items-center justify-between mb-4">
//                     <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-semibold bg-white shadow-sm border border-gray-100 ${event.textColor}`}>
//                       <MapPin size={14} />
//                       {event.city}
//                     </span>
//                     <span className="text-2xl font-black text-gray-300 group-hover:text-gray-400 transition-colors duration-300">
//                       {event.date.split(', ')[1]}
//                     </span>
//                   </div>

//                   {/* Hotel Name */}
//                   <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-gray-950 transition-colors">
//                     {event.hotel}
//                   </h3>
//                 </div>

//                 {/* Date Wrapper */}
//                 <div className="mt-6 flex items-center gap-2 text-gray-600 border-t border-gray-100 pt-4">
//                   <Calendar size={16} className="text-gray-400" />
//                   <span className="text-sm font-medium">{event.date}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EventSchedule;


import React, { useState } from 'react';

const EventSchedule = () => {
  // State to handle hover effects for each card independently
  const [hoveredCard, setHoveredCard] = useState(null);

  const events = [
    {
      id: 0,
      hotel: "ITC Grand Chola",
      city: "Chennai",
      year: "2027",
      date: "June 1 - 5, 2027",
      themeColor: "#d97706", // Amber
      lightBg: "#fef3c7"
    },
    {
      id: 1,
      hotel: "ITC Royal Bengal",
      city: "Kolkata",
      year: "2028",
      date: "June 1 - 5, 2028",
      themeColor: "#2563eb", // Blue
      lightBg: "#dbeafe"
    }
  ];

  // Inline Style Objects
  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      backgroundColor: '#f9fafb',
     // minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      boxSizing: 'border-box'
    },
    headerSection: {
      textAlign: 'center',
      marginBottom: '40px'
    },
    heading: {
      fontSize: '32px',
      fontWeight: '800',
      color: '#111827',
      margin: '0 0 8px 0',
      letterSpacing: '-0.5px'
    },
    subheading: {
      fontSize: '16px',
      color: '#6b7280',
      margin: 0
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '24px',
      width: '100%',
      maxWidth: '800px'
    },
    card: (isHovered, themeColor) => ({
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      border: `1px solid ${isHovered ? themeColor : '#e5e7eb'}`,
      padding: '24px',
      boxShadow: isHovered 
        ? '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' 
        : '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
      transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'between',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden'
    }),
    topRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    },
    badge: (themeColor, lightBg) => ({
      backgroundColor: lightBg,
      color: themeColor,
      fontWeight: '600',
      fontSize: '14px',
      padding: '6px 12px',
      borderRadius: '20px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px'
    }),
    yearText: {
      fontSize: '24px',
      fontWeight: '900',
      color: '#e5e7eb',
      letterSpacing: '0.5px'
    },
    hotelName: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#1f2937',
      margin: '0 0 24px 0',
      lineHeight: '1.4'
    },
    footerRow: {
      borderTop: '1px solid #f3f4f6',
      paddingTop: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: '#4b5563',
      fontSize: '14px',
      fontWeight: '500'
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerSection}>
        <h2 style={styles.heading}>ALL India Schooling</h2>
        <p style={styles.subheading}>Join us for our upcoming flagship events.</p>
      </div>

      {/* Grid wrapper */}
      <div style={styles.grid}>
        {events.map((event) => {
          const isHovered = hoveredCard === event.id;
          
          return (
            <div
              key={event.id}
              style={styles.card(isHovered, event.themeColor)}
              onMouseEnter={() => setHoveredCard(event.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div>
                {/* City Badge & Big Year Background */}
                <div style={styles.topRow}>
                  <span style={styles.badge(event.themeColor, event.lightBg)}>
                    📍 {event.city}
                  </span>
                  <span style={{ 
                    ...styles.yearText, 
                    color: isHovered ? event.themeColor : '#e5e7eb',
                    opacity: isHovered ? 0.2 : 1,
                    transition: 'all 0.3s ease'
                  }}>
                    {event.year}
                  </span>
                </div>

                {/* Hotel Name */}
                <h3 style={styles.hotelName}>{event.hotel}</h3>
              </div>

              {/* Date Footer */}
              <div style={styles.footerRow}>
                <span>📅</span>
                <span>{event.date}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventSchedule;